import { render, staticRenderFns } from "./Sales_Filter.vue?vue&type=template&id=3678e945&scoped=true&"
import script from "./Sales_Filter.vue?vue&type=script&lang=js&"
export * from "./Sales_Filter.vue?vue&type=script&lang=js&"
import style0 from "./Sales_Filter.vue?vue&type=style&index=0&id=3678e945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678e945",
  null
  
)

export default component.exports